var map = {
	"./About.vue": [
		"f820",
		"about"
	],
	"./Home.vue": [
		"bb51"
	],
	"./economy/BuildingPermit.vue": [
		"c65c",
		"chunk-585f2f7f"
	],
	"./economy/HomeIndexPrice.vue": [
		"df43",
		"chunk-92ffb082"
	],
	"./economy/MichiganGDP.vue": [
		"440d",
		"chunk-0e15489c"
	],
	"./economy/NaturalGas.vue": [
		"3742",
		"chunk-9c8fbf40"
	],
	"./economy/OilPrices.vue": [
		"5025",
		"chunk-d62f3cc8"
	],
	"./economy/PerCapPersonal.vue": [
		"d3ef",
		"chunk-6a83f32e"
	],
	"./economy/USHousing.vue": [
		"b477",
		"chunk-59cb06f0"
	],
	"./economy/USLightVehicle.vue": [
		"5b88",
		"chunk-71e752cb"
	],
	"./economy/USRetail.vue": [
		"1fc9",
		"chunk-1c48d1ee"
	],
	"./economy/VehicleProd.vue": [
		"5bca",
		"chunk-451661a9"
	],
	"./industryJobs/AvgHrsEarnManufactur.vue": [
		"4a65",
		"chunk-56b9a9ac"
	],
	"./industryJobs/AvgWeekHrsManufactur.vue": [
		"a815",
		"chunk-2f9e2bce"
	],
	"./industryJobs/GovPayroll.vue": [
		"3b3f",
		"chunk-6498bc40"
	],
	"./industryJobs/PayrollCon.vue": [
		"fb68",
		"chunk-2e0a9bfc"
	],
	"./industryJobs/PayrollFA.vue": [
		"721f",
		"chunk-41f6f724"
	],
	"./industryJobs/PayrollInfo.vue": [
		"81e8",
		"chunk-249be3ac"
	],
	"./industryJobs/PayrollLeisure.vue": [
		"e189",
		"chunk-998bf6aa"
	],
	"./industryJobs/PayrollManufact.vue": [
		"3822",
		"chunk-dfc72cba"
	],
	"./industryJobs/PayrollMineLog.vue": [
		"abd3",
		"chunk-7925f3a4"
	],
	"./industryJobs/PayrollOther.vue": [
		"05d9",
		"chunk-56ec1798"
	],
	"./industryJobs/PayrollPrivateEduHeath.vue": [
		"e570",
		"chunk-7d940e87"
	],
	"./industryJobs/PayrollProBusiness.vue": [
		"1a4b",
		"chunk-6563207c"
	],
	"./industryJobs/PayrollTrade.vue": [
		"80c0",
		"chunk-6ace4763"
	],
	"./industryJobs/PriSecPayroll.vue": [
		"053c",
		"chunk-b74ce4da"
	],
	"./laborForce/CoveredEmployment.vue": [
		"a14f",
		"chunk-e34e39c0"
	],
	"./laborForce/HouseEmploy.vue": [
		"fd36",
		"chunk-a0219e42"
	],
	"./laborForce/LaborForce.vue": [
		"8cbd8",
		"chunk-37380e67"
	],
	"./laborForce/LaborForceParticipation.vue": [
		"432f",
		"chunk-a6d9fe1e"
	],
	"./laborForce/LaborPartByState.vue": [
		"37ff",
		"chunk-019b8662",
		"chunk-2d0bab1a"
	],
	"./laborForce/OnlineVsUnemploy.vue": [
		"a6dc",
		"chunk-4813fe32"
	],
	"./laborForce/PayrollJobs.vue": [
		"c934",
		"chunk-68d669d5"
	],
	"./laborForce/PercentPopEmp.vue": [
		"36a7",
		"chunk-626020d7"
	],
	"./laborForce/PvtGrossJobGainLoss.vue": [
		"329e",
		"chunk-9d4380ae"
	],
	"./population/EducationAttain.vue": [
		"26b6",
		"chunk-2dd03554"
	],
	"./population/MichiganPopuation.vue": [
		"ee1c",
		"chunk-47cc8920"
	],
	"./unemployment/InitClaim4Unemploy.vue": [
		"1aeb",
		"chunk-121e3b2b"
	],
	"./unemployment/LaborUnderUtil.vue": [
		"2a04",
		"chunk-1bb7b71e"
	],
	"./unemployment/LongTermUnemploy.vue": [
		"3088",
		"chunk-2856fb4a"
	],
	"./unemployment/PartTimeRate.vue": [
		"1341",
		"chunk-b127da46"
	],
	"./unemployment/UnemployByEdu.vue": [
		"2c22",
		"chunk-279e6daf"
	],
	"./unemployment/UnemployByState.vue": [
		"8690",
		"chunk-019b8662",
		"chunk-2d0de78b"
	],
	"./unemployment/Unemployment.vue": [
		"e268",
		"chunk-6ec552a6"
	],
	"./unemployment/YouthUnemploy.vue": [
		"0051",
		"chunk-51444d9a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;